import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Tabs } from '../elements-buttons/tab-buttons';
import { Responsiveness } from '../elements-responsiveness/responsiveness';

export class TabsContainer extends React.Component {
  render () {
    const { tabs, loc, showResponsive, hostResponse } = this.props;
    const level = _.get(hostResponse, 'level', 1);
    const responseTime = _.get(hostResponse, 'hours', 0);

    return (
      <div className="flex space-between column-sm-reverse">
        <div>
          <Tabs tabs={tabs} loc={loc} />
        </div>
        {
          showResponsive && responseTime ?
            <div className="responsiveness-col relative">
              {
                <div ref={(node) => { this.tooltipParent = node; }} >
                  <div className="responsiveness-inbox">
                    <Responsiveness
                      level={level}
                      responseTime={responseTime}
                      tooltipParent={this.tooltipParent}
                      tooltipPlacement={{ top: -5 }}
                    />
                  </div>
                </div>
              }
            </div> : null
        }
      </div>
    );
  }
}

TabsContainer.propTypes = {
  tabs: PropTypes.array,
  loc: PropTypes.string,
  showResponsive: PropTypes.bool,
  hostResponse: PropTypes.object
};
